export default function NotFound() {
  const error = new Error('Not Found');
  //@ts-ignore
  error.status = 404;

  throw error;
}
